import { render, staticRenderFns } from "./ImportKvkModal.vue?vue&type=template&id=2ea02888&scoped=true&"
import script from "./ImportKvkModal.vue?vue&type=script&lang=js&"
export * from "./ImportKvkModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportKvkModal.vue?vue&type=style&index=0&id=2ea02888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea02888",
  null
  
)

export default component.exports